import React, { PureComponent } from 'react';
import { getAudioPrimed } from '../constants/Meta';
import Styles, { noSelect, disableLongPressBS } from '../constants/Styles';
import { getUnitName } from '../vodjs/lib.js';
import { isMobile } from '../vodjs/Utils.js';
import { countForReload, argSubscribe, getRobotId } from '../vodjs/lib.js';

const mobile = isMobile();

export default class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.tappableRef = React.createRef();
    this.state = { changeId: 1 };
  }

  bumpChangeId() {
    this.setState({ changeId: (this.state.changeId || 0) + 1 });
  }

  componentDidMount() {
    //re-render in case unit name changes
    this.unsubscribeArgTypes = argSubscribe((argTypes) => this.bumpChangeId());
  }

  componentWillUnmount() {
    if (this.unsubscribeArgTypes) {
      this.unsubscribeArgTypes();
      this.unsubscribeArgTypes = undefined;
    }
  }

  countTap(e) {
    let r = this.tappableRef.current.getBoundingClientRect();
    let side = e.clientX < (r.left + r.right) / 2 ? 'L' : 'R';
    console.log(side);
    countForReload({ label: 'DRHeader', side, sideAgnostic: !!this.props.isPreStation });
  }

  render() {
    let { unit, isPreStation } = this.props;
    isPreStation = !!isPreStation;

    let textShadow = getAudioPrimed() ? undefined : '0px 0px 20px red';

    let primeAudioFunc;
    if (this.props.primeAudio)
      primeAudioFunc = () => {
        this.props.primeAudio(true);
        this.bumpChangeId();
      };

    let unitName = !isPreStation ? (getRobotId() ? getRobotId() : unit ? unit : getUnitName()) : undefined;
    //let unitName = !isPreStation ? (getRobotId() ? 'Moxi' : getUnitName()) : undefined;

    const airdropIconSz = mobile || isPreStation ? 24 : 30;
    const gripperIconSz = mobile || isPreStation ? 24 : 45;
    const moxiFontSz = mobile || isPreStation ? 20 : 30;

    return (
      <div
        ref={this.tappableRef}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          paddingTop: 20,
          ...noSelect,
        }}
        onClick={(e) => this.countTap(e)}
      >
        <img
          draggable="false"
          src={require('../assets/images/blue_gripper.png')}
          style={{ width: gripperIconSz, height: gripperIconSz, ...disableLongPressBS }}
        />
        <div id="moxi_od_title" style={{ flex: 1, fontWeight: 600, fontSize: moxiFontSz, alignSelf: 'center' }}>
          Moxi OnDemand
        </div>

        {this.props.moreControls}

        <img
          draggable="false"
          src={require('../assets/images/icon-airdrop.png')}
          style={{ height: airdropIconSz, width: airdropIconSz, marginRight: 10, ...disableLongPressBS }}
          onClick={primeAudioFunc}
        />
        {!!unitName && (
          <div
            style={{
              fontWeight: 700,
              fontSize: 24,
              alignSelf: 'center',
              color: '#2D9CA4',
              marginRight: '3%',
              textShadow,
            }}
            onClick={primeAudioFunc}
          >
            {unitName}
          </div>
        )}
      </div>
    );
  }
}
